export function digitsOnly(value) {
  return String(value || "").replace(/\D/g, "").slice(0, 13);
}
